import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCheckbox,{staticClass:"my-0 py-0",attrs:{"label":_vm.$t('Admin.feedback.resolved'),"disabled":_vm.loading,"color":"primary","hide-details":""},on:{"change":_vm.feedbackSolve},model:{value:(_vm.markupValue),callback:function ($$v) {_vm.markupValue=$$v},expression:"markupValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }